<template>
    <div class="content">
        <div class="content-head">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="汇款单位">
                    <el-input autocomplete="on" name="Receipt_Code" v-model="params.Receipt_Code" class="el-select-medium" placeholder="" clearable></el-input>
                </el-form-item>
                <el-form-item label="审核状态">
                    <el-select v-model="params.MK_Status" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in Statusopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getDisaccords(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh" :loading="loadingBtn">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title">
                汇款不一致说明管理
                <el-dropdown trigger="click">
                    <el-button type="primary">
                        导出
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <span @click="getDisaccords_Export_All()">导出查询信息</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <el-table  :row-class-name="tableRowClassName" @row-click="handleRowClick" :data="tableData" :height="maxheight" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                <!-- <el-table-column prop="MK_DisaccordID" label="ID" width="100" align="center" fixed="left"></el-table-column> -->
                <el-table-column prop="Receipt_Code" label="汇款单位" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="MK_OrdersERPSN" label="ERP订单号" align="center" show-overflow-tooltip width="140"></el-table-column>
                <el-table-column prop="Orders_CustomerName" label="需方名称" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Orders_Total_AllPrice" label="订单总金额" align="center" show-overflow-tooltip width="130">
                    <template slot-scope="scope">￥ {{ scope.row.Orders_Total_AllPrice }}</template>
                </el-table-column>
                <el-table-column prop="Receipt_TotalAmount" label="汇款金额" align="center" show-overflow-tooltip width="130">
                    <template slot-scope="scope">￥ {{ scope.row.Receipt_TotalAmount }}</template>
                </el-table-column>
                <el-table-column prop="Receipt_Amount" label="本次分配金额" align="center" show-overflow-tooltip width="130">
                    <template slot-scope="scope">￥ {{ scope.row.Receipt_Amount }}</template>
                </el-table-column>
                <el-table-column prop="AuditStatus" label="审核状态" align="center" show-overflow-tooltip width="130"></el-table-column>
                <el-table-column prop="MK_ScanTime" label="审核时间" align="center" show-overflow-tooltip width="140">
                    <template slot-scope="scope">
                        {{ scope.row.MK_ScanTime | formatDates }}
                    </template>
                </el-table-column>
                <el-table-column prop="MK_AddTime" label="添加时间" align="center" show-overflow-tooltip width="140">
                    <template slot-scope="scope">
                        {{ scope.row.MK_AddTime | formatDates }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="100" fixed="right">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleOpen(scope.row)">上传说明</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <!-- ----------------详情信息-------------------->
        <el-dialog title="上传说明" :visible.sync="isDrawer" :before-close="handleClose" width="1200px" :close-on-click-modal="false">
            <div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">ERP订单号 ：</div>
                            <div>{{ details.MK_OrdersERPSN }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">订单需方：</div>
                            <div>{{ details.Orders_CustomerName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">待审核第三方名称：</div>
                            <div>{{ details.Receipt_Code }}</div>
                        </div>
                    </el-col>

                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">订单总金额：</div>
                            <div>{{ details.Orders_Total_AllPrice }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">凭证信息：</div>
                            <div v-if="details.Payment_Receipt_File" class="operation-bar-block-a" @click="downFile(details.Payment_Receipt_File)">{{ details.Payment_Receipt_File }}</div>
                            <div v-else>暂无相关附件信息</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">凭证金额：</div>
                            <div>{{ details.Receipt_TotalAmount }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">本次分配金额：</div>
                            <div>{{ details.Receipt_Amount }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">送审原因：</div>
                            <div>{{ details.MK_Note }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24" v-if="details.MK_File">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">付款不一致说明：</div>
                            <div class="operation-bar-block-a" @click="downFile(details.MK_File)">{{ details.MK_File }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24" v-if="details.MK_File">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">重新上传不一致说明：</div>
                            <div>
                                <Hwupload ref="Hwupload" v-if="isDrawer" />
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24" v-else>
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">上传付款不一致说明：</div>
                            <div>
                                <Hwupload ref="Hwupload" v-if="isDrawer" />
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">审核日志：</div>
                            <el-table :data="statusLogs" border :header-cell-style="{ backgroundColor: '#F5F7FA' }" style="width: 1000px">
                                <el-table-column prop="Credit_Control_Orders_SN" label="序号" align="center" width="80">
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Log_AddTime" label="时间" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.Log_AddTime | formatDates }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Log_User" label="操作人" align="center"></el-table-column>
                                <el-table-column prop="Log_Remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
                <el-button @click="handleClose()">关闭</el-button>
                <el-button type="primary" @click="onSubmit()">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue';
import Hwupload from '@/components/Hwupload/index.vue';
import { myMixin } from '@/utils/mixin.js';
import { cloneDeep, debounce } from 'lodash';
import { downloadFile } from '@/utils/utils.js';
export default {
    name: 'inconsistentDeclaration',
    mixins: [myMixin],
    components: {
        Pagination,
        Hwupload
    },
    data() {
        return {
            loadingBtn: false,
            isDrawer: false,
            details: {
                Payment_Receipt_File: '',
                MK_AddTime: '',
                MK_DisaccordID: 22,
                MK_File: '',
                MK_Note: '',
                MK_OfficeCode: '',
                MK_OfficeManCode: '',
                MK_OrdersERPSN: '',
                MK_OrdersID: 3503,
                MK_ScanTime: '',
                MK_Status: 0,
                Orders_CustomerName: '',
                Orders_Total_AllPrice: 0,
                Payment_Receipt_User: '',
                Receipt_AddrID: 54,
                Receipt_Amount: 0,
                Receipt_Code: '',
                Receipt_File: '',
                Receipt_ID: 912,
                Receipt_ReceiptID: 716,
                Receipt_TotalAmount: 0
            },
            params: {
                Receipt_Code: '',
                MK_Status: 0
            },
            statusLogs: [],
            tableData: [],
            Statusopt: [
                { value: 0, label: '待上传附件' },
                { value: 1, label: '已审核' },
                { value: 2, label: '未通过审核' },
                { value: 3, label: '待审批' }
            ]
        };
    },
    mounted() {
        this.getDisaccords();
    },
    methods: {
        onSubmit: debounce(function () {
            const result = {
                json: JSON.stringify({
                    MK_DisaccordID: this.details.MK_DisaccordID,
                    MK_File: this.$refs.Hwupload.filePath
                })
            };
            this.$newsApi.getEditDisaccord(result).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 2000,
                        onClose: () => {
                            this.isDrawer = false;
                        }
                    });
                }
            });
        }, 800),

        /*
   日志信息
   */
        getMKLogsByTargetID(Receipt_ID) {
            this.$newsApi.getMKLogsByTargetID({ Target_ID: Receipt_ID, Target_Type: 0 }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.statusLogs = res.data.data;
                }
            });
        },

        /*
    重置查询
    */
        onRefresh() {
            this.params = {
                Receipt_Code: '',
                MK_Status: 0
            };
            this.getDisaccords(true);
        },
        /*
    列表查询
    */
        getDisaccords(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi
                .getDisaccords(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    } else {
                        this.tableData = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },

        filteropt() {
            let params = cloneDeep(this.params);
            return { json: JSON.stringify(params), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        /*
    详情信息查询
    */
        getDisaccordByID(id) {
            this.$newsApi.getDisaccordByID({ id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.getOrdersPaymentReceiptByID(res.data.data);
                }
            });
        },
        /*
    凭证信息查询
    */
        async getOrdersPaymentReceiptByID(data) {
            const res = await this.$newsApi.getOrdersPaymentReceiptByID({ Receipt_ID: data.Receipt_ReceiptID, action: '' });
            this.details = data;
            if (res.data.Resultcode == 0) {
                this.details.Payment_Receipt_File = res.data.data.Payment_Receipt_File;
            }
            this.getMKLogsByTargetID(data.MK_DisaccordID);
            console.log(res);
        },
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getDisaccords();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getDisaccords();
        },
        handleClose() {
            this.isDrawer = false;
        },
        handleOpen(row) {
            this.isDrawer = true;
            this.getDisaccordByID(row.MK_DisaccordID);
        },
        // 导出
        getDisaccords_Export_All() {
            this.$newsApi.Disaccords_Export_All(this.filteropt()).then((res) => {
                if (res.data.Resultcode == 0) {
                    downloadFile(res.data.data, res.data.Resultinfo);
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.hw-form-item {
    padding: 10px 0;
    display: flex;
    align-items: center;

    &-label {
        text-align: right;
        width: 140px;
    }
}
.content-head {
    padding: 15px 20px 5px 20px;
}
.el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
</style>
